import type { IconSvgObject } from './types';

const ElectricityStackIcon: IconSvgObject = [
  ["path", { d: "M9 3H19C20.1046 3 21 3.89543 21 5V15C21 16.1046 20.1046 17 19 17H9C7.89543 17 7 16.1046 7 15V5C7 3.89543 7.89543 3 9 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 7V19C3 20.1046 3.89543 21 5 21H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 7L12 10H16L14 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ElectricityStackIcon;
